/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookFileDto from './BookFileDto';
import CategoryDto from './CategoryDto';
import LanguageDto from './LanguageDto';
import OrganizationObjectDto from './OrganizationObjectDto';
import ProductTypeDto from './ProductTypeDto';

/**
 * The BookBaseDto model module.
 * @module model/BookBaseDto
 * @version v1.0.0
 */
class BookBaseDto {
    /**
     * Constructs a new <code>BookBaseDto</code>.
     * @alias module:model/BookBaseDto
     */
    constructor() { 
        
        BookBaseDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookBaseDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookBaseDto} obj Optional instance to populate.
     * @return {module:model/BookBaseDto} The populated <code>BookBaseDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookBaseDto();

            if (data.hasOwnProperty('author')) {
                obj['author'] = ApiClient.convertToType(data['author'], 'String');
            }
            if (data.hasOwnProperty('bookComment')) {
                obj['bookComment'] = ApiClient.convertToType(data['bookComment'], 'String');
            }
            if (data.hasOwnProperty('bookIsbn')) {
                obj['bookIsbn'] = ApiClient.convertToType(data['bookIsbn'], 'String');
            }
            if (data.hasOwnProperty('categories')) {
                obj['categories'] = ApiClient.convertToType(data['categories'], [CategoryDto]);
            }
            if (data.hasOwnProperty('ctsid')) {
                obj['ctsid'] = ApiClient.convertToType(data['ctsid'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('inventory')) {
                obj['inventory'] = ApiClient.convertToType(data['inventory'], 'Number');
            }
            if (data.hasOwnProperty('languages')) {
                obj['languages'] = ApiClient.convertToType(data['languages'], [LanguageDto]);
            }
            if (data.hasOwnProperty('lastUpdate')) {
                obj['lastUpdate'] = ApiClient.convertToType(data['lastUpdate'], 'Number');
            }
            if (data.hasOwnProperty('mainBookId')) {
                obj['mainBookId'] = ApiClient.convertToType(data['mainBookId'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('organization')) {
                obj['organization'] = OrganizationObjectDto.constructFromObject(data['organization']);
            }
            if (data.hasOwnProperty('originalPrice')) {
                obj['originalPrice'] = ApiClient.convertToType(data['originalPrice'], 'Number');
            }
            if (data.hasOwnProperty('price')) {
                obj['price'] = ApiClient.convertToType(data['price'], 'Number');
            }
            if (data.hasOwnProperty('productType')) {
                obj['productType'] = ProductTypeDto.constructFromObject(data['productType']);
            }
            if (data.hasOwnProperty('publishDate')) {
                obj['publishDate'] = ApiClient.convertToType(data['publishDate'], 'Number');
            }
            if (data.hasOwnProperty('root')) {
                obj['root'] = ApiClient.convertToType(data['root'], 'Boolean');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('translator')) {
                obj['translator'] = ApiClient.convertToType(data['translator'], 'String');
            }
            if (data.hasOwnProperty('uploadedFiles')) {
                obj['uploadedFiles'] = BookFileDto.constructFromObject(data['uploadedFiles']);
            }
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
        }
        return obj;
    }


}

/**
 * 作者
 * @member {String} author
 */
BookBaseDto.prototype['author'] = undefined;

/**
 * 書評
 * @member {String} bookComment
 */
BookBaseDto.prototype['bookComment'] = undefined;

/**
 * ISBN/產品編號
 * @member {String} bookIsbn
 */
BookBaseDto.prototype['bookIsbn'] = undefined;

/**
 * 分類
 * @member {Array.<module:model/CategoryDto>} categories
 */
BookBaseDto.prototype['categories'] = undefined;

/**
 * @member {String} ctsid
 */
BookBaseDto.prototype['ctsid'] = undefined;

/**
 * 產品簡介
 * @member {String} description
 */
BookBaseDto.prototype['description'] = undefined;

/**
 * book id
 * @member {String} id
 */
BookBaseDto.prototype['id'] = undefined;

/**
 * inventory
 * @member {Number} inventory
 */
BookBaseDto.prototype['inventory'] = undefined;

/**
 * languages
 * @member {Array.<module:model/LanguageDto>} languages
 */
BookBaseDto.prototype['languages'] = undefined;

/**
 * last update
 * @member {Number} lastUpdate
 */
BookBaseDto.prototype['lastUpdate'] = undefined;

/**
 * mainBookId
 * @member {String} mainBookId
 */
BookBaseDto.prototype['mainBookId'] = undefined;

/**
 * 產品名稱
 * @member {String} name
 */
BookBaseDto.prototype['name'] = undefined;

/**
 * @member {module:model/OrganizationObjectDto} organization
 */
BookBaseDto.prototype['organization'] = undefined;

/**
 * 原價
 * @member {Number} originalPrice
 */
BookBaseDto.prototype['originalPrice'] = undefined;

/**
 * 售價
 * @member {Number} price
 */
BookBaseDto.prototype['price'] = undefined;

/**
 * @member {module:model/ProductTypeDto} productType
 */
BookBaseDto.prototype['productType'] = undefined;

/**
 * 出版日期
 * @member {Number} publishDate
 */
BookBaseDto.prototype['publishDate'] = undefined;

/**
 * @member {Boolean} root
 */
BookBaseDto.prototype['root'] = undefined;

/**
 * 狀態
 * @member {module:model/BookBaseDto.StatusEnum} status
 */
BookBaseDto.prototype['status'] = undefined;

/**
 * 譯者
 * @member {String} translator
 */
BookBaseDto.prototype['translator'] = undefined;

/**
 * @member {module:model/BookFileDto} uploadedFiles
 */
BookBaseDto.prototype['uploadedFiles'] = undefined;

/**
 * version
 * @member {String} version
 */
BookBaseDto.prototype['version'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
BookBaseDto['StatusEnum'] = {

    /**
     * value: "APPLY_UNAVAILABLE"
     * @const
     */
    "APPLY_UNAVAILABLE": "APPLY_UNAVAILABLE",

    /**
     * value: "APPROVED"
     * @const
     */
    "APPROVED": "APPROVED",

    /**
     * value: "AVAILABLE"
     * @const
     */
    "AVAILABLE": "AVAILABLE",

    /**
     * value: "REJECTED"
     * @const
     */
    "REJECTED": "REJECTED",

    /**
     * value: "SUBMITTED"
     * @const
     */
    "SUBMITTED": "SUBMITTED",

    /**
     * value: "TEMP"
     * @const
     */
    "TEMP": "TEMP",

    /**
     * value: "UNAVAILABLE"
     * @const
     */
    "UNAVAILABLE": "UNAVAILABLE"
};



export default BookBaseDto;

